import React, { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ListBox } from '@progress/kendo-react-listbox';
import API from "../../../services/api";
import AuthContext from '../../../context/Auth/AuthContext';
import Notifications, { ERROR_NOTIFICATION, INFO_NOTIFICATION } from '../../../helpers/notifications';

const SELECTED_FIELD = "selected";
const SelectBenefit = (props) => {
    // we call the hook to make translations
    const { t } = useTranslation('common');


    // * list and selected option
    const [existingBenefits, setExistingBenefits] = useState([]);
    const [availableBenefits, setAvailableBenefits] = useState([]);
    const [selectedBenefit, setSelectedBenefit] = useState({});

    // Session context to get the current institution data
    const { get_currentInstitution } = useContext(AuthContext);


    useEffect(() => {
        getBenefits();
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    const getBenefits = async () => {
        try {
            const resScenarioBenefits = await API.get(`/Scenario/GetBenefits?scenarioId=${props.scenarioId}`);
            const resAvailableBenefits = await API.get(`/Scenario/GetBenefitsNotInScenario?institutionId=${get_currentInstitution().catInstitutionId}&scenarioId=${props.scenarioId}`);
            if (resAvailableBenefits.data.code !== 100) {
                Notifications.notify(t(resAvailableBenefits.data.msg), ERROR_NOTIFICATION);
                return;
            }
            if (resScenarioBenefits.data.code !== 100) {
                Notifications.notify(t(resScenarioBenefits.data.msg), ERROR_NOTIFICATION);
                return;
            }
            setExistingBenefits(resScenarioBenefits.data.data);



            setAvailableBenefits(resAvailableBenefits.data.data.map((item, i) => {
                if (i === 0) {
                    item[SELECTED_FIELD] = true;
                } else {
                    item[SELECTED_FIELD] = false;
                }

                return item;
            }));

            setSelectedBenefit(resAvailableBenefits.data.data[0] ? resAvailableBenefits.data.data[0] : {});

            //clear
            props.setSelectedBenefit({});

        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error)
        }

    }
    // * Sets the active item after click
    const handleItemClick = (event) => {
        setAvailableBenefits(
            availableBenefits.map((item) => {
                if (item.name === event.dataItem.name) {
                    item[SELECTED_FIELD] = true;
                } else {
                    item[SELECTED_FIELD] = false;
                }

                return item;
            })
        );
        setSelectedBenefit(event.dataItem);
    };

    return (
        <div className="container-fluid m-1 add_benefit_step_container">

            <div className="form-group row add_benefit_title">
                <div className="col-md-12 pt-2">
                    <p>{t('scenarios.addBenefit_desc')}</p>
                </div>
            </div>

            <div className="form-group row add_benefit_body">
                <div className="form-group col-md-6">
                    <label className="ilo_lbl_general" style={{ fontWeight: "bold" }}>{t('scenarios.add_benefit.availableBenefits')}</label>
                    <ListBox
                        style={{
                            height: 400,
                            width: "100%",
                        }}
                        data={availableBenefits}
                        textField="name"
                        selectedField={SELECTED_FIELD}
                        onItemClick={(e) => handleItemClick(e)}

                    />
                </div>
                <div className="form-group col-md-6">
                    <label className="ilo_lbl_general" style={{ fontWeight: "bold" }}>{t('scenarios.add_benefit.includedBenefits')}</label>
                    <ListBox
                        style={{
                            height: 400,
                            width: "100%",
                        }}
                        data={existingBenefits}
                        textField="name"
                    />

                </div>                
            </div>

            <div className="row arrows_position add_benefit_buttons">
                <div className="col-sm-12">
                    <button onClick={() => { props.goBack() }} className="btn btn-primary ilo-btn mr-2">{t('scenarios.add_benefit.cancel')}</button>
                    <button
                        onClick={() => {

                            if (Object.keys(selectedBenefit).length !== 0) {
                                props.setSelectedBenefit(selectedBenefit);
                                props.changeView('link_benefit_andGroups');
                            } else {
                                Notifications.notify(t(`scenarios.add_benefit.no_benefit_selected`), INFO_NOTIFICATION);
                            }

                        }}
                        className="btn btn-primary ilo-btn"
                    >{t('scenarios.add_benefit.link_with_groups')}</button>
                </div>
            </div>

        </div>
    )
}

export default SelectBenefit;
